// Every walkthrough, in the order Admin → Management → Walkthroughs lists
// them. Add a file beside the feature's PR and list it here; the vitest
// (help/__tests__/walkthroughs.test.ts) checks it and the e2e spec runs it.

import { aiModelsInUse } from './ai-models-in-use'
import { aiUsageDataSources } from './ai-usage-data-sources'
import { analysisProfile } from './analysis-profile'
import { aroundTablesCard } from './around-tables-card'
import { bayesPriceSkills } from './bayes-price-skills'
import { chiefOfStaffMode } from './chief-of-staff-mode'
import { demosReset } from './demos-reset'
import { dynamicCodeFrames } from './dynamic-code-frames'
import { guidedConversations } from './guided-conversations'
import { guideReviewers } from './guide-reviewers'
import { legendSymbol } from './legend-symbol'
import { presentations } from './presentations'
import { skillDraftSave } from './skill-draft-save'
import { skillRefresh } from './skill-refresh'
import { skyTeamDashboards } from './sky-team-dashboards'
import { socialAccounts } from './social-accounts'
import { socialPosts } from './social-posts'
import { themeAIJunkCheck } from './theme-ai-junk-check'
import { themeAIPersonalData } from './theme-ai-personal-data'
import { twoStepLogin } from './two-step-login'
import type { Walkthrough } from './types'
import { whatsNew20261030 } from './whats-new-2026-10-30'

export type { Walkthrough, WalkStep } from './types'
export { canStartWalkthrough, walkthroughToRun } from './types'

export const WALKTHROUGHS: Walkthrough[] = [aroundTablesCard, skyTeamDashboards, socialAccounts, socialPosts, themeAIJunkCheck, themeAIPersonalData, dynamicCodeFrames, demosReset, chiefOfStaffMode, twoStepLogin, aiModelsInUse, guidedConversations, analysisProfile, guideReviewers, skillDraftSave, legendSymbol, whatsNew20261030, bayesPriceSkills, skillRefresh, aiUsageDataSources, presentations]

export function walkthroughBySlug(slug: string): Walkthrough | undefined {
  return WALKTHROUGHS.find((w) => w.slug === slug)
}
